import React, { MouseEvent, ReactElement, useCallback } from 'react';
import classNames from 'classnames';
import { Icon, ICON_NAME, ICON_SIZE } from 'b2b-components/theme/components/Icon';
import { useRouterPush } from 'b2b-apps/shop/routes/hooks';
import { openLink } from 'b2b-apps/shop/routes/utils/url';
import { ComponentType, Props } from './';
import './MoreLink.scss';

const MoreLink: ComponentType = (props: Props): ReactElement => {
  const { url, label, className } = props;
  const push = useRouterPush();

  const handleClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>): void => {
      e.preventDefault();
      openLink(url, push, e);
    },
    [url, push],
  );

  return (
    <a
      className={classNames('cds-Link', 'MoreLink', className)}
      href={url}
      onClick={handleClick}
    >
      {label}
      &nbsp;
      <Icon
        className="MoreLink-Icon"
        name={ICON_NAME.arrowRight}
        size={ICON_SIZE.xsmall}
      />
    </a>
  );
};

export { MoreLink };
